import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { flow, map as mapFP, filter as filterFP } from 'lodash/fp';
import { includes } from 'lodash';
import { Row, Col } from 'reactstrap';
import { useAppKeyWords } from 'hooks';
import { getCurrency } from 'enums/currencyEnum';
import { Button, IconButton, Layout, SelectReduxFormWrapper } from '@hub-mono/ui';

const RenderRates = ({ fields, type, resources, resourceIdsInCustomRates, rates }) => {
    const { resourceKeyWord } = useAppKeyWords();

    const resourcesOptions = useMemo(() => {
        return resources
            .filter(resource => !includes(resourceIdsInCustomRates, resource._id))
            .map(resource => {
                let textField = '';

                if (Object.keys(resource).length) {
                    if (!resource.firstName && !resource.firstName) {
                        textField = `Deleted / archived ${resourceKeyWord}`;
                    } else {
                        const baseName = `${resource.firstName || ''} ${resource.lastName || ''}`;
                        if ('UNASSIGNED' === resource.type) {
                            textField = `${baseName} (unassigned)`;
                        } else {
                            textField = baseName;
                        }
                    }
                }

                return {
                    ...resource,
                    textField: textField,
                };
            });
    }, [resourceIdsInCustomRates, resourceKeyWord, resources]);

    const ratesOptions = useMemo(() => {
        return rates.map(item => {
            return {
                ...item,
                textField: item?.label ? `${item.label}: ${getCurrency(item.currency).symbol} ${item.rate}` : '',
            };
        });
    }, [rates]);

    return (
        <Layout stack gap="--Spacing-150">
            {fields.map((rate, index) => (
                <Row key={index} className="mb-2">
                    <Col xs={12} md={6}>
                        <Field
                            name={`${rate}.resource`}
                            component={SelectReduxFormWrapper}
                            optionValue="_id"
                            optionLabel="textField"
                            options={resourcesOptions}
                        />
                    </Col>
                    <Col xs={12} md={5}>
                        <Field
                            name={`${rate}.rate`}
                            component={SelectReduxFormWrapper}
                            optionValue="_id"
                            optionLabel="textField"
                            options={ratesOptions}
                        />
                    </Col>
                    <Col xs={12} md={1}>
                        <IconButton icon="delete" onClick={() => fields.remove(index)} />
                    </Col>
                </Row>
            ))}
            <Layout>
                <Button variant="text" startIcon="add" onClick={() => fields.push({})}>
                    Add a Custom {type} Rate
                </Button>
            </Layout>
        </Layout>
    );
};

const CustomResourceRates = ({ resourceRates, resources, rates, type }) => {
    const resourceIdsInCustomRates = flow(
        filterFP(rate => rate.resource && rate.resource._id),
        mapFP(rate => rate.resource._id)
    )(resourceRates);

    return (
        <FieldArray
            name={`projectRates.${type}.customRates`}
            component={RenderRates}
            type={type}
            rates={rates}
            resources={resources}
            resourceIdsInCustomRates={resourceIdsInCustomRates}
        />
    );
};

CustomResourceRates.propTypes = {
    rates: PropTypes.array,
    resourceRates: PropTypes.array,
    resources: PropTypes.array,
    type: PropTypes.string,
    projectKeyWord: PropTypes.string,
};

CustomResourceRates.defaultProps = {
    rates: [],
    resourceRates: [],
    resources: [],
    type: 'external',
    projectKeyWord: '',
};

export default CustomResourceRates;
